
import Vue from 'vue'
export const Utils= new Vue()
